import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles as sharedStyles } from '../../styles/shared-styles';
import '../../components/bottom-tabs';
import { t } from '../../translations';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';


@customElement('app-aurora')
export class AppAurora extends LitElement {
  static styles = [
    sharedStyles,
    css`
      :host {
        display: block;
        background: #0D1726;
        color: white;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
      }
      .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        box-sizing: border-box;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 16px;
        padding-bottom: 120px; /* Increased padding: ensure content clears tabs */
      }

      @supports (padding-bottom: env(safe-area-inset-bottom)) {
        .container {
          padding-left: calc(16px + env(safe-area-inset-left));
          padding-right: calc(16px + env(safe-area-inset-right));
          padding-bottom: calc(120px + env(safe-area-inset-bottom));
        }
      }
      .section {
        background: #0D1726;
        border-radius: 8px;
        padding: 2rem 1rem 1.5rem 1rem;
        margin: 2rem 0 0 0;
        width: 100%;
        max-width: 600px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      
      .section:last-child {
        margin-bottom: 0; /* Remove extra margin, padding-bottom on container handles this */
      }
      .section img {
        width: 100%;
        max-width: 400px;
        height: auto;
        border-radius: 6px;
        margin: 1rem 0;
        object-fit: contain;
        background: #0D1726;
      }
      .section-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 1rem;
        text-align: center;
      }
      .section-text {
        font-size: 1rem;
        opacity: 0.9;
        margin-bottom: 0.5rem;
        text-align: left;
      }
      .page-title {
        font-size: 2.2rem;
        font-weight: bold;
        margin-top: 4rem;
        text-align: center;
        letter-spacing: 0.05em;
      }
    `
  ];

  render() {
    return html`
      <div class="container">
        <div class="page-title">${t('aurora')}</div>
        <div class="section">
          <div class="section-title">${t('auroraTitle1')}</div>
          <img src="assets/knowledge/1_quick_guide.png" alt="${t('auroraTitle1')}">
          <div class="section-text">${unsafeHTML(t('auroraText1'))}</div>
        </div>
        <div class="section">
          <div class="section-title">${t('auroraTitle2')}</div>
          <img src="assets/knowledge/2_global_phenomena.png" alt="${t('auroraTitle2')}">
          <div class="section-text">${unsafeHTML(t('auroraText2'))}</div>
        </div>
        <div class="section">
          <div class="section-title">${t('auroraTitle3')}</div>
          <img src="assets/knowledge/3_the_sun.png" alt="${t('auroraTitle3')}">
          <div class="section-text">${unsafeHTML(t('auroraText3'))}</div>
        </div>
        <div class="section">
          <div class="section-title">${t('auroraTitle4')}</div>
          <img src="assets/knowledge/4_color.png" alt="${t('auroraTitle4')}">
          <div class="section-text">${unsafeHTML(t('auroraText4'))}</div>
        </div>
        <div class="section">
          <div class="section-title">${t('auroraTitle5')}</div>
          <img src="assets/knowledge/5_aurora_forms.png" alt="${t('auroraTitle5')}">
          <div class="section-text">${unsafeHTML(t('auroraText5'))}</div>
        </div>
        <div class="section">
          <div class="section-title">${t('auroraTitle6')}</div>
          <img src="assets/knowledge/6_aurora.png" alt="${t('auroraTitle6')}">
          <div class="section-text">${unsafeHTML(t('auroraText6'))}</div>
        </div>
        <div class="section">
          <div class="section-title">${unsafeHTML(t('auroraTitle7'))}</div>
          <img src="assets/knowledge/7_myths.png" alt="${t('auroraTitle7')}">
          <div class="section-text">${unsafeHTML(t('auroraText7'))}</div>
        </div>
      </div>
      <bottom-tabs></bottom-tabs>
    `;
  }
}